// Check if we're in react-snap pre-rendering
const IS_SNAP = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

const isMobile = () => {
  // During react-snap, use the viewport width which we've set to 1440 (desktop)
  // This ensures pre-rendered HTML matches desktop layout
  if (IS_SNAP) {
    return false; // Pre-render as desktop
  }

  if (typeof window === 'undefined') {
    return false; // SSR fallback to desktop
  }

  // Replaced unmaintained mobile-detect (2018, regex over UA strings) with the
  // platform-native pair:
  //   1. UA Client Hints (modern Chromium/Edge) — authoritative mobile boolean.
  //   2. `pointer: coarse` — covers touch UAs that don't expose UA-CH (Safari,
  //      Firefox), and also catches tablets.
  //   3. Viewport ≤ 599px — matches MUI's `sm` breakpoint so JS `isMobile`
  //      stays in sync with the CSS `theme.breakpoints.down('sm')` switch.
  if (navigator.userAgentData?.mobile) return true;
  if (typeof window.matchMedia === 'function') {
    if (window.matchMedia('(pointer: coarse)').matches) return true;
    return window.matchMedia('(max-width: 599px)').matches;
  }
  return window.innerWidth < 600;
};

const initialState = {
  openDrawer: false,
  user: null,
  backendUser: null,
  isMobile: isMobile()
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_OPEN_DRAWER':
      return { ...state, openDrawer: action.payload };
    case 'SET_LOCAL_SIGN_IN_REDIRECT':
      return { ...state, localSignInRedirect: action.payload };
    case 'SET_USER':
      return {
        ...state,
        user: action.payload,
        // Firebase can sign out independently of the explicit LOGOUT action.
        // Do not leave backend roles from the previous account in memory.
        ...(action.payload ? {} : { backendUser: null })
      };
    case 'PING_SUCCESS':
      // Firebase's user object does not contain application roles. `/auth`
      // supplies the backend user record used by role-aware navigation.
      return { ...state, backendUser: action.payload?.user || null };
    default:
      return state;
  }
};

export default rootReducer;
